/**
 * Roboticks color palette - matches the main roboticks-web design system.
 */

export const grey = {
  25: '#F9FAFB',
  50: '#F6F7F8',
  100: '#f3f4f6',
  200: '#e5e7eb',
  300: '#d1d5db',
  400: '#9ca3af',
  500: '#6b7280',
  600: '#4b5563',
  700: '#374151',
  800: '#1f2937',
  900: '#111827',
};

export const primary = {
  25: '#F0F7FF',
  50: '#E6F2FF',
  100: '#CCE5FF',
  200: '#99CBFF',
  300: '#66B0FF',
  400: '#3396FF',
  500: '#4040FF',
  600: '#0066CC',
  700: '#004D99',
  800: '#003366',
  900: '#001A33',
  main: '#4040ff',
};

export const success = {
  25: '#F0FDF5',
  50: '#DCFCE8',
  100: '#BBF7D1',
  200: '#86EFAD',
  300: '#4ADE80',
  400: '#22C55E',
  500: '#16A34A',
  600: '#15803D',
  700: '#166534',
  800: '#14532D',
  900: '#052E16',
  main: '#22C55E',
};

export const warning = {
  25: '#FFFBEB',
  50: '#FEF3C7',
  100: '#FDE68A',
  200: '#FCD34D',
  300: '#FBBF24',
  400: '#F59E0B',
  500: '#D97706',
  600: '#B45309',
  700: '#92400E',
  800: '#78350F',
  900: '#451A03',
  main: '#F59E0B',
};

export const error = {
  25: '#FEF2F2',
  50: '#FEE2E2',
  100: '#FECACA',
  200: '#FCA5A5',
  300: '#F87171',
  400: '#EF4444',
  500: '#DC2626',
  600: '#B91C1C',
  700: '#991B1B',
  800: '#7F1D1D',
  900: '#450A0A',
  main: '#EF4444',
};

export const secondary = {
  ...grey,
  main: '#F6F7F8',
};

export const info = {
  light: '#EAEAFE',
  main: '#8282FB',
  dark: '#5151D3',
};
